import { withCompInfo } from '@wix/editor-elements-integrations'
import { createDataSchema } from '@wix/thunderbolt-components-native'
import * as yup from 'yup'
import type { CompDefinition } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const InnerElementDataSchema = createDataSchema(
	'InnerElement',
	yup.object({
		styleId: yup.string(),
		dataQuery: yup.string(),
	})
)

export type PlatformBuilderDefinition = CompDefinition<
	never,
	yup.InferType<typeof InnerElementDataSchema>,
	never,
	never
>

export type PlatformBuilderProps = {}

export const props = withCompInfo<PlatformBuilderProps, PlatformBuilderDefinition>()(
	// @ts-ignore
	['innerElementsDataOverrides', 'compPathsToSelectors'],
	// @ts-ignore
	({ innerElementsDataOverrides, compPathsToSelectors }) => {
		const innerElementsToRemove = _.keys(innerElementsDataOverrides).reduce((acc: Array<string>, compPath) => {
			const override = innerElementsDataOverrides[compPath]
			const elementsRemovalState = override?.wix?.elementsRemovalState || {}
			const compPaths = _.keys(_.pickBy(elementsRemovalState, (value) => value === 'REMOVED')).map(
				(nickname) => `${compPath}/${nickname}`
			)
			return acc.concat(compPaths)
		}, [])

		const dataOverrides = _.pickBy(
			_.mapValues(innerElementsDataOverrides, (override) => override.data),
			(val) => val !== undefined
		)

		return { innerElementsToRemove, innerElementsDataOverrides: dataOverrides, compPathsToSelectors }
	}
)
